import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Imagen } from '../../../../interfaces/imagen';
import { DomSanitizer } from '@angular/platform-browser';
import { FileHolder } from 'angular2-image-upload';
import { ArchivoProducto } from '../../../../interfaces/archivo-producto';
import { ProductoService } from '../../../../providers/producto.service';

@Component({
  selector: 'app-subir-archivos-producto',
  templateUrl: './subir-archivos-producto.component.html',
  styleUrls: ['./subir-archivos-producto.component.scss']
})
export class SubirArchivosProductoComponent {
  imagenes: Imagen[] = <Imagen[]>[];
  imageUploadEstados = [];
  imageUploadProgressValue: number;
  imageUploadProgressLimit: number;
  cargandoImagenes: boolean = false;

  archivos: ArchivoProducto[] = <ArchivoProducto[]>[];
  archivoUploadEstados = [];
  archivoUploadProgressValue: number;
  archivoUploadProgressLimit: number;
  cargandoArchivos: boolean = false;

  IdProducto: number | string;
  @Output() onArchivoInput = new EventEmitter(); // datos del formulario cambian
  @Output() onCargandoArchivos = new EventEmitter<boolean>(); // carngado 
  @Output() onArchivosSubidos = new EventEmitter<boolean>(); // carngado 
  @Input() mostrarSubir: boolean = true;

  constructor(
    private productoService: ProductoService,
    private _sanitizer: DomSanitizer
  ) { }

  onInput(): void {
    this.imageUploadEstados = [];
    this.archivoUploadEstados = [];
    this.onArchivoInput.emit();
  }

  getSecureUrl(url) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

  setCargando(cargando: boolean): void {
    this.onCargandoArchivos.emit(cargando);
  }

  onImagenCargada(fileHolder: FileHolder): void {
    this.imagenes.push(<Imagen>{
      src: fileHolder.src,
      nombre: fileHolder.file.name
    });
  }

  onImagenQuitada(fileHolder: FileHolder) {
    this.imagenes.forEach((imagen: Imagen, index: number) => {
      if (imagen.nombre == fileHolder.file.name && imagen.src == fileHolder.src) {
        this.imagenes.splice(index, 1);
      }
    });
  }

  onArchivoCargado(fileHolder: FileHolder): void {
    this.archivos.push(<ArchivoProducto>{
      src: fileHolder.src,
      nombre: fileHolder.file.name
    });
  }

  onArchivoQuitado(fileHolder: FileHolder) {
    this.archivos.forEach((archivo: ArchivoProducto, index: number) => {
      if (archivo.nombre == fileHolder.file.name && archivo.src == fileHolder.src) {
        this.archivos.splice(index, 1);
      }
    });
  }

  onSubirArchivos(): void {
    this.setCargando(true);
    this.cargandoImagenes = true;
    this.cargandoArchivos = true;

    // Subir imágenes
    this.imageUploadEstados = [];
    this.imageUploadProgressValue = 0;
    this.imageUploadProgressLimit = this.imagenes.length;
    if (this.imagenes.length > 0) {
      this.enviarImagenAlSv(this.imagenes[0]);
    } else {
      this.cargandoImagenes = false;
      this.archivosCargados();
    }

    // Subir archivos
    this.archivoUploadEstados = [];
    this.archivoUploadProgressValue = 0;
    this.archivoUploadProgressLimit = this.archivos.length;
    if (this.archivos.length > 0) {
      this.enviarArchivoAlSv(this.archivos[0]);
    } else {
      this.cargandoArchivos = false;
      this.archivosCargados();
    }
  }

  enviarImagenAlSv(imagen: Imagen): void {
    this.productoService.subirImagenesProducto(
      this.IdProducto,
      [imagen]
    ).subscribe(
      respuesta => {
        if (respuesta) {
          this.imageUploadEstados.push({
            nombre: imagen.nombre,
            estado: respuesta.estado,
            mensaje: respuesta.mensaje,
            src: imagen.src
          });
        }

        this.imagenEnviada();
      },
      error => {
        this.imageUploadEstados.push({
          nombre: imagen.nombre,
          estado: 2,
          mensaje: error,
          src: imagen.src
        });
        this.imagenEnviada();
      }
    );
  }

  imagenEnviada(): void {
    this.imagenes.splice(0, 1);
    if (this.imagenes.length > 0) {
      this.imageUploadProgressValue = 100 * (this.imageUploadProgressLimit - this.imagenes.length) / this.imageUploadProgressLimit;
      this.enviarImagenAlSv(this.imagenes[0]);
    } else {
      this.cargandoImagenes = false;
      this.archivosCargados();
    }
  }

  enviarArchivoAlSv(archivo: ArchivoProducto): void {
    this.productoService.subirArchivosProducto(
      this.IdProducto,
      [archivo]
    ).subscribe(
      respuesta => {
        if (respuesta) {
          this.archivoUploadEstados.push({
            nombre: archivo.nombre,
            estado: respuesta.estado,
            mensaje: respuesta.mensaje,
            src: archivo.src
          });
        }

        this.archivoEnviado();
      },
      error => {
        this.archivoUploadEstados.push({
          nombre: archivo.nombre,
          estado: 2,
          mensaje: error,
          src: archivo.src
        });
        this.archivoEnviado();
      }
    );
  }

  archivoEnviado(): void {
    this.archivos.splice(0, 1);
    if (this.archivos.length > 0) {
      this.archivoUploadProgressValue = 100 * (this.archivoUploadProgressLimit - this.archivos.length) / this.archivoUploadProgressLimit;
      this.enviarArchivoAlSv(this.archivos[0]);
    } else {
      this.cargandoArchivos = false;
      this.archivosCargados();
    }
  }

  archivosCargados(): void {
    if (!this.cargandoImagenes && !this.cargandoArchivos) {
      this.setCargando(false);

      // Le damos al list de estados unos milisegundos para que se dibuje
      setTimeout(() => {
        this.onArchivosSubidos.emit();
      }, 10);
    }
  }

  /**
   * Retorna true si hay errores durante la carga de archivos
   */
  hasErrors(): boolean {
    return this.archivoUploadEstados.filter(archivoSubido => archivoSubido.estado != 1).length != 0;
  }
}
